(() => {
  angular
    .module('gm.common.directives')
    .directive('gmLoading', gmLoadingDirective);

  /**
   * Marketing website.
   * Manage loading content on the page.
   *
   * @param {Object} $rootScope
   */
  function gmLoadingDirective(
    $rootScope,
    $timeout
  ) {
    'ngInject';

    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'modules/common/directives/loading/loading.html',

      link(scope) {
        let timeout;

        scope.isDisplayed = false;
        scope.isLoading = true;

        $rootScope.$on('gm:loading', (_event, isLoading) => {
          scope.isLoading = isLoading;

          if (timeout) {
            $timeout.cancel(timeout);
          }

          if (isLoading) {
            scope.isDisplayed = true;
          } else {
            timeout = $timeout(() => {
              scope.isDisplayed = false;
            }, 1005);
          }
        });

        scope.$on('$destroy', () => {
          if (timeout) {
            timeout.cancel();
          }
        });
      },
    };
  }
})();
